module.exports = __webpack_public_path__ + "static/product-page-banner-sizes-84696a861daeeba3f1872c088c87e680.png";